// frontend/src/components/reputation/GmbCommandModal.jsx
// Version: 2.0 (quick-260916-wll — отказ меняет вид экрана)
// Description: Пульт управления Google Business Profile: 7-факторный аудит,
//              генератор и публикатор постов, ответы на отзывы, каталог услуг
//              и настройки автопилота.
//
// 🔴 ЧТО УБРАНО 17.09.2026. В `catch` загрузки стоял блок подстановки: когда
//    ручка ОТКАЗЫВАЛА, экран рисовал правдоподобную картину — просмотры,
//    поиски, звонки, оценку аудита, четыре услуги и отметку «синхронизировано
//    только что» РОВНО В МОМЕНТ ОТКАЗА. Отказ уходил в `console.warn`, то есть
//    человеку не показывался вообще. Кнопки «Sync Now» и «Re-Run Audit» в
//    `catch` печатали ЗЕЛЁНЫЙ УСПЕХ: «Sync complete», «Audit updated».
//
// 🔴 ПРОВЕРКА СЕБЯ, КОТОРУЮ ЗДЕСЬ НАДО ДЕРЖАТЬ: «если источник не ответит,
//    экран станет выглядеть иначе?» Не станет — правка не сделана.
//
// 🔴 НОЛЬ И «НЕ ИЗМЕРЕНО» — РАЗНЫЕ СОСТОЯНИЯ МИРА. Печатать величины только
//    через `pokazatVelichinu`: запись `{v || '—'}` превратила бы измеренный
//    ноль звонков в прочерк, то есть в «не измеряли».
//
// 🔴 ЧЕГО ЭТОТ ЭКРАН НЕ ЗНАЕТ: истинности чисел, которые отдала ручка. Две
//    существующие боевые строки `gmb_locations` до сих пор содержат выдумку
//    (скрипт сброса НЕ ЗАПУСКАЛСЯ), и экран честно покажет ИХ содержимое.
//
// 🔴 ЧТО ЗАПРЕЩЕНО ЗДЕСЬ С 17.09.2026 (quick-260917-06b):
//    · КЛИК, ПОРОЖДАЮЩИЙ ЛОЖНОЕ ОЖИДАНИЕ. Кнопка «Sync Now» нажималась
//      всегда, а ручка за ней ставила «синхронизировано» с Google, ничего у
//      Google не спросив. Теперь кнопка ВЫКЛЮЧЕНА, пока Google не подключён
//      или запись в состоянии NOT_CONNECTED, и подсказка называет причину.
//    · КЛИК, ПОРОЖДАЮЩИЙ ПУСТОЙ ЗАПРОС: обращение «на всякий случай» само по
//      себе создаёт у человека ожидание ответа Google.
//    · ТОСТ, УТВЕРЖДАЮЩИЙ СИНХРОНИЗАЦИЮ, КОГДА ОБМЕНА НЕ БЫЛО. Успех
//      печатается ТОЛЬКО при `result.status === 'synced'`.
// 🔴 ЧТО ЗАПРЕЩЕНО ЗДЕСЬ С 17.09.2026 ДОПОЛНИТЕЛЬНО (quick-260917-23g):
//    · ПЕРЕСОБИРАТЬ ПРАВИЛО ГОТОВНОСТИ. Готовность к синхронизации решает
//      СЕРВЕР и присылает готовым признаком `can_sync`; его держатель —
//      `gmb_service.pravilo_gotovnosti_k_sync`. Писать здесь
//      `connected && has_gmb_scope` (или любую часть этого условия как рубеж
//      перед действием) нельзя: копий правила станет больше, а разошлись уже
//      имевшиеся две.
//    · ЧИТАТЬ «ПОЛЯ НЕТ» КАК «МОЖНО». Сравнение строго с `true`: ответ старой
//      формы, отказ ручки и неприход ответа обязаны ВЫКЛЮЧАТЬ кнопку.
//      Незнание не равно разрешению.
//    · СКЛЕИВАТЬ ПОДСКАЗКИ «нет аккаунта» и «нет прав Business Profile»: это
//      разные работы человека, и общий текст отправляет его не туда.
// 🔴 ПРОВЕРКА СЕБЯ ДЛЯ ЭТОГО ЭКРАНА: «если Google не подключён, отличается ли
//    экран от подключённого?» Не отличается — правка не сделана.

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import {
  X,
  Sparkles,
  RefreshCw,
  Send,
  CheckCircle2,
  AlertTriangle,
  ExternalLink,
  MapPin,
  Calendar,
  MessageSquare,
  Briefcase,
  Sliders,
  ShieldCheck,
  TrendingUp,
  Clock,
  Eye,
  PhoneCall,
  Search,
  Check,
  FileText,
  Bot,
  Copy,
  Camera,
  Image as ImageIcon,
  Upload,
  Trash2,
  CheckSquare
} from 'lucide-react';
import { useUiLanguage, perevesti } from '../../context/UiLanguageContext';

/**
 * 🔴 ЕДИНСТВЕННЫЙ СПОСОБ НАПЕЧАТАТЬ ВЕЛИЧИНУ. `null`/`undefined` — «не
 * измеряли», прочерк; ноль — ОТВЕТ и печатается нулём. Запись `{v || '—'}`
 * здесь запрещена: ноль в JS ложен, и измеренный ноль звонков напечатался бы
 * как «не измерено».
 */
export const pokazatVelichinu = (v) => (v === null || v === undefined ? '—' : String(v));

export const PlashkaSostoyaniya = ({ otkazZagruzki, location }) => {
  const { lang: rawLang } = useUiLanguage();
  const lang = rawLang || 'ru';
  const t = (k, v) => perevesti(lang, k, v);

  const nePodklyuchenTekst = t('rep.modal.gmb.not_connected_warning');

  if (otkazZagruzki) {
    return (
      <div data-plashka="otkaz" className="p-4 rounded-xl border bg-[#FBEAEA] border-[#E5B5B5] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">{t('rep.modal.gmb.status.unknown_query_failed')}</span>
        <p className="mt-0.5 text-[#687077]">{t('rep.modal.gmb.status.failure_reason', { reason: otkazZagruzki, warning: nePodklyuchenTekst })}</p>
      </div>
    );
  }
  if (!location) {
    return (
      <div data-plashka="net-otveta" className="p-4 rounded-xl border bg-[#F8F7F2] border-[#E5E1D6] text-xs leading-relaxed text-[#687077]">
        {t('rep.modal.gmb.status.pending_response')}
      </div>
    );
  }
  if (location.sync_status === 'error') {
    return (
      <div data-plashka="oshibka" className="p-4 rounded-xl border bg-[#FBEAEA] border-[#E5B5B5] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">{t('rep.modal.gmb.status.sync_error')}</span>
        <p className="mt-0.5 text-[#687077]">{location.sync_error || t('rep.modal.gmb.status.reason_not_specified')}</p>
      </div>
    );
  }
  if (location.sync_status === 'synced') {
    return (
      <div data-plashka="synced" className="p-4 rounded-xl border bg-[#E6F6EE] border-[#B7E5D0] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">{t('rep.modal.gmb.status.synced')}</span>
        <p className="mt-0.5 text-[#687077]">
          {t('rep.modal.gmb.status.sync_moment', { date: location.last_synced_at ? location.last_synced_at : t('rep.modal.gmb.not_synced') })}
        </p>
      </div>
    );
  }
  if (location.sync_status === 'NOT_CONNECTED') {
    return (
      <div data-plashka="ne-podklyuchen" className="p-4 rounded-xl border bg-[#FAF4E5] border-[#E5D7B5] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">{nePodklyuchenTekst}</span>
        <p className="mt-0.5 text-[#687077]">{t('rep.modal.gmb.status.not_connected_state')}</p>
      </div>
    );
  }
  // 🔴 Значение статуса вне закрытого перечня (NOT_CONNECTED, synced, pending,
  //    error) — это НЕ «не подключён» и не «синхронизировано»: неизвестное
  //    называется неизвестным, а не приводится к ближайшему знакомому.
  return (
    <div data-plashka="neopoznan" className="p-4 rounded-xl border bg-[#F8F7F2] border-[#E5E1D6] text-xs leading-relaxed text-[#20231F]">
      <span className="font-bold">{t('rep.modal.gmb.status.unrecognized', { status: pokazatVelichinu(location.sync_status) })}</span>
      <p className="mt-0.5 text-[#687077]">{t('rep.modal.gmb.status.known_values')}</p>
    </div>
  );
};

export const GmbCommandModal = ({ isOpen, onClose, office }) => {
  const { lang: rawLang } = useUiLanguage();
  const lang = rawLang || 'ru';
  const t = (k, v) => perevesti(lang, k, v);

  const POKAZATELI = [
    ['views_30d', t('rep.modal.gmb.metric.views')],
    ['searches_30d', t('rep.modal.gmb.metric.searches')],
    ['calls_30d', t('rep.modal.gmb.metric.calls')],
    ['website_clicks_30d', t('rep.modal.gmb.metric.website_clicks')],
    ['directions_30d', t('rep.modal.gmb.metric.directions')],
  ];

  const [activeTab, setActiveTab] = useState('audit'); // 'audit', 'posts', 'reviews', 'services', 'autopilot'
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [auditing, setAuditing] = useState(false);
  const [generatingPost, setGeneratingPost] = useState(false);
  // Attorney Photo Media Vault state
  const [availablePhotos, setAvailablePhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [photoCategory, setPhotoCategory] = useState('all');
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [showPhotoVault, setShowPhotoVault] = useState(false);
  const [publishingPost, setPublishingPost] = useState(false);
  
  // Data state
  const [locationData, setLocationData] = useState(null);
  // 🔴 Отказ загрузки — ТРЕТЬЕ состояние, а не «данных нет»: «не смогли
  //    спросить» и «спросили, ответили пусто» выглядят на экране по-разному.
  const [otkazZagruzki, setOtkazZagruzki] = useState(null);
  const [posts, setPosts] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [latestAudit, setLatestAudit] = useState(null);

  // Post form state
  const [postTopic, setPostTopic] = useState('');
  const [postSummary, setPostSummary] = useState('');
  const [postCtaType, setPostCtaType] = useState('BOOK');
  const [postCtaUrl, setPostCtaUrl] = useState('https://fitenkolaw.com/consultation');

  // Review reply state
  const [replyingReviewId, setReplyingReviewId] = useState(null);
  const [replyDrafts, setReplyDrafts] = useState({});
  const [submittingReply, setSubmittingReply] = useState(false);

  // Autopilot settings state
  const [autopilotEnabled, setAutopilotEnabled] = useState(true);
  const [autopilotWeeklyPost, setAutopilotWeeklyPost] = useState(true);
  const [autopilotReviewReply, setAutopilotReviewReply] = useState(true);
  const [autopilotPostDay, setAutopilotPostDay] = useState('Monday');

  // Google OAuth status
  // 🔴 `can_sync: false` в начальном состоянии: ДО ответа ручки экран обязан
  //    вести себя как «нельзя». Отсутствие признака — не разрешение.
  const [authStatus, setAuthStatus] = useState({ connected: false, has_gmb_scope: false, email: '', can_sync: false });
  const [connectingGoogle, setConnectingGoogle] = useState(false);

  const fetchAttorneyPhotos = async () => {
    try {
      const res = await axios.get('/api/v1/reputation/gmb/media/photos');
      if (res.data?.photos) {
        setAvailablePhotos(res.data.photos);
        if (!selectedPhoto && res.data.photos.length > 0) {
          const defaultPhoto = res.data.photos.find(p => p.category === 'portrait' || p.category === 'action') || res.data.photos[0];
          setSelectedPhoto(defaultPhoto);
        }
      }
    } catch (err) {
      console.error('Failed to fetch attorney photos', err);
    }
  };

  const handleBulkUploadPhotos = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    if (files.length > 50) {
      toast.error(t('rep.modal.gmb.toast.photos_max_50'));
      return;
    }
    setUploadingPhotos(true);
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    try {
      const res = await axios.post('/api/v1/reputation/gmb/media/photos/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data?.success) {
        toast.success(t('rep.modal.gmb.toast.photos_uploaded', { count: res.data.uploaded_count }));
        await fetchAttorneyPhotos();
      }
    } catch (err) {
      toast.error(t('rep.modal.gmb.toast.photos_error'));
    } finally {
      setUploadingPhotos(false);
      if (e.target) e.target.value = '';
    }
  };

  const profileId = office?.id;
  const initialOfficeKey = office?.key || office?.kluch || office?.office_key || (['coral-springs', 'hallandale-beach'].includes(office?.id) ? office.id : '');
  const [selectedOfficeKey, setSelectedOfficeKey] = useState(initialOfficeKey);

  useEffect(() => {
    const k = office?.key || office?.kluch || office?.office_key || (['coral-springs', 'hallandale-beach'].includes(office?.id) ? office.id : '');
    setSelectedOfficeKey(k);
  }, [office]);

  // Load dashboard data on open
  useEffect(() => {
    if (!isOpen || !profileId) return;

    fetchAttorneyPhotos();
    const fetchGmbData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`/api/v1/reputation/gmb/locations/${profileId}?office_key=${encodeURIComponent(selectedOfficeKey)}`);
        setOtkazZagruzki(null);
        if (res.data) {
          setLocationData(res.data.location);
          setPosts(res.data.posts || []);
          setReviews(res.data.reviews || []);
          setLatestAudit(res.data.latest_audit);
          if (res.data.location) {
            setAutopilotEnabled(res.data.location.autopilot_enabled);
            setAutopilotWeeklyPost(res.data.location.autopilot_weekly_post);
            setAutopilotReviewReply(res.data.location.autopilot_review_auto_reply);
            setAutopilotPostDay(res.data.location.autopilot_post_day || 'Monday');
          }
        }
      } catch (err) {
        // 🔴 НИ ОДНОЙ ПОДСТАНОВКИ. Ручка не ответила — значит мы не знаем
        //    ничего, и экран обязан выглядеть ИНАЧЕ, а не правдоподобно.
        console.warn('GMB: запрос состояния отказал:', err);
        setLocationData(null);
        setLatestAudit(null);
        setPosts([]);
        setReviews([]);
        setOtkazZagruzki((err && err.message) || t('rep.modal.gmb.status.reason_not_specified'));
      } finally {
        setLoading(false);
      }
    };

    const fetchAuthStatus = async () => {
      try {
        const aRes = await axios.get('/api/v1/reputation/gmb/auth/status');
        if (aRes.data) {
          setAuthStatus(aRes.data);
        }
      } catch (err) {
        console.warn('GMB Auth status check failed:', err);
      }
    };

    fetchGmbData();
    fetchAuthStatus();
  }, [isOpen, profileId, office, selectedOfficeKey]);

  if (!isOpen || !office) return null;

  // 🔴 ГОТОВНОСТЬ РЕШАЕТ СЕРВЕР (quick-260917-23g). Здесь стояла ВТОРАЯ КОПИЯ
  //    правила доступа — `Boolean(authStatus?.connected)`, — и она разошлась с
  //    сервером в первый же день: ручка отдавала `has_gmb_scope: false`,
  //    кнопка включалась, подсказка обещала обращение к Google, а сервер
  //    отказывал «нет разрешения business.manage». Собирать условие здесь
  //    заново (`connected && has_gmb_scope`) ЗАПРЕЩЕНО: это была бы четвёртая
  //    копия того же правила.
  // 🔴 ОТКАЗ В БЕЗОПАСНУЮ СТОРОНУ: сравнение строгое с `true`. Поля нет
  //    (старый бэкенд, ручка ответила иначе, ответ не пришёл) — кнопка
  //    ВЫКЛЮЧЕНА. Незнание не равно разрешению.
  const mozhnoSync = authStatus?.can_sync === true;
  const zapisNePodklyuchena = locationData?.sync_status === 'NOT_CONNECTED';
  const sostoyanieNeizvestno = !locationData;   // ручка не ответила
  const knopkaVyklyuchena = syncing || !mozhnoSync || zapisNePodklyuchena || sostoyanieNeizvestno;

  // 🔴 ПОДСКАЗКИ РАЗДЕЛЕНЫ, ПОТОМУ ЧТО ВЕДУТ К РАЗНЫМ ДЕЙСТВИЯМ ЧЕЛОВЕКА:
  //    «подключить аккаунт» и «переавторизоваться с правами Business Profile» —
  //    разные работы, и одна подсказка на оба случая отправляет человека не туда.
  // 🔴 НАШ ТЕКСТ называет ДЕЙСТВИЕ, сообщение сервера — ПРИЧИНУ. Это не одно и
  //    то же, поэтому сообщение сервера ДОПИСЫВАЕТСЯ дословно, а не подменяет
  //    наш текст и не подменяется им.
  // 🔴 ПОРЯДОК ВЕТОК ЗНАЧИМ: `mozhnoSync` судится ПЕРВЫМ после `syncing`.
  //    Поставив `!connected` раньше, мы получили бы экран, который при
  //    `can_sync: true` и `connected: false` показывает «требуется
  //    подключение» у ВКЛЮЧЁННОЙ кнопки — подсказка противоречила бы кнопке.
  let podskazkaSync;
  if (syncing) {
    podskazkaSync = t('rep.modal.gmb.tooltip.syncing');
  } else if (!mozhnoSync) {
    let svoy;
    if (!authStatus?.connected) {
      svoy = t('rep.modal.gmb.tooltip.no_account');
    } else if (authStatus?.has_gmb_scope === false) {
      svoy = t('rep.modal.gmb.tooltip.no_scope');
    } else {
      // Поля `can_sync` нет, а прочие признаки ни о чём не говорят: сервер
      // готовность НЕ ПОДТВЕРДИЛ, и это отдельное состояние мира.
      svoy = t('rep.modal.gmb.tooltip.no_can_sync');
    }
    podskazkaSync = authStatus?.message ? t('rep.modal.gmb.tooltip.server_prefix', { hint: svoy, msg: authStatus.message }) : svoy;
  } else if (sostoyanieNeizvestno) {
    podskazkaSync = t('rep.modal.gmb.tooltip.status_unknown');
  } else if (zapisNePodklyuchena) {
    podskazkaSync = t('rep.modal.gmb.tooltip.not_connected');
  } else {
    podskazkaSync = t('rep.modal.gmb.tooltip.ready');
  }

  // Handler: Manual 24h Sync
  const handleSyncNow = async () => {
    setSyncing(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/sync?office_key=${encodeURIComponent(selectedOfficeKey)}`);
      const itog = (res && res.data && res.data.result) || {};
      // 🔴 Отметку времени ставит СЕРВЕР. Считать её часами браузера значило
      //    бы завести второго держателя момента, который разойдётся молча.
      const moment = itog.last_synced_at || null;
      setLocationData(prev => (prev ? {
        ...prev,
        last_synced_at: moment,
        sync_status: itog.status || prev.sync_status,
        sync_error: itog.prichina || null,
      } : prev));
      // 🔴 ТОСТ СТРОГО ПО ФАКТУ. Синхронизацией зовётся ТОЛЬКО ответ Google:
      //    здесь стояло «Синхронизация выполнена ручкой» при любом исходе,
      //    включая тот, в котором к Google никто не обращался.
      if (itog.status === 'synced') {
        toast.success(t('rep.modal.gmb.toast.sync_ok'));
      } else {
        toast.error(t('rep.modal.gmb.toast.sync_skipped', { reason: itog.prichina || t('rep.modal.gmb.status.reason_not_specified') }));
      }
    } catch (err) {
      // 🔴 Здесь печатался ЗЕЛЁНЫЙ УСПЕХ НА ОТКАЗЕ: «Sync complete. Live
      //    Google metrics verified». Ничего не синхронизировано и ничего не
      //    проверено — отметка времени поэтому НЕ МЕНЯЕТСЯ.
      // 🔴 Тот же род беды, что и в аудите: причина с сервера обязана дойти
      //    до человека, а не подменяться номером кода ответа.
      toast.error(t('rep.modal.gmb.toast.sync_failed', {
        reason: (err && err.response && err.response.data && err.response.data.detail)
          || (err && err.message)
          || t('rep.modal.gmb.status.reason_not_specified'),
      }));
    } finally {
      setSyncing(false);
    }
  };

  // Handler: Run AI 7-Factor Audit
  const handleRunAudit = async () => {
    setAuditing(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/audit?office_key=${encodeURIComponent(selectedOfficeKey)}`);
      if (res.data) {
        setLatestAudit(res.data);
        toast.success(t('rep.modal.gmb.toast.audit_ok', { score: pokazatVelichinu(res.data.overall_score) }));
      }
    } catch (err) {
      // 🔴 ПРИЧИНА, НАЗВАННАЯ СЕРВЕРОМ СЛОВАМИ, ОБЯЗАНА ДОЙТИ ДО ЧЕЛОВЕКА
      //    (quick-260917-1bw). Здесь печаталось `err.message`, то есть
      //    «Request failed with status code 502»: сервер называл причину
      //    («ключ модели не задан», «ответ модели не разобран»), а человек
      //    видел номер. Номер не говорит, что чинить.
      const prichina = (err && err.response && err.response.data && err.response.data.detail)
        || (err && err.message)
        || t('rep.modal.gmb.status.reason_not_specified');
      toast.error(t('rep.modal.gmb.toast.audit_failed', { reason: prichina }));
    } finally {
      setAuditing(false);
    }
  };

  // Handler: Connect Google OAuth
  const handleConnectGoogle = async () => {
    setConnectingGoogle(true);
    try {
      const res = await axios.get('/api/v1/reputation/gmb/auth/url');
      if (res.data?.authorization_url) {
        window.open(res.data.authorization_url, '_blank');
        toast.success(t('rep.modal.gmb.toast.google_auth_opened'));
      }
    } catch (err) {
      toast.error(t('rep.modal.gmb.toast.google_auth_failed'));
    } finally {
      setConnectingGoogle(false);
    }
  };

  // Helper: Get direct URLs for the active office
  const getOfficeGoogleUrls = () => {
    // 🔴 Ни города, ни имени фирмы по умолчанию: и то и другое приходит из
    //    карточки офиса (канон держателя `app/services/ofisy.py`).
    const cityName = office?.location_name?.split(',')[0] || '';
    const query = encodeURIComponent([office?.company_name, cityName].filter(Boolean).join(' '));
    return {
      searchManageUrl: `https://www.google.com/search?q=${query}`,
      // 🔴 Ссылки на карты по умолчанию нет: адрес чужой записи в Google —
      //    утверждение о мире, и выдумывать его нельзя.
      mapsUrl: office?.gmb_url || null,
      locationsListUrl: 'https://business.google.com/locations'
    };
  };

  // Handler: Copy Post & Open Google Maps Profile
  const handleCopyAndOpenGoogle = (customText) => {
    const textToCopy = customText || postSummary;
    if (!textToCopy.trim()) {
      toast.error(t('rep.modal.gmb.toast.post_content_empty'));
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy);
    }
    const { searchManageUrl } = getOfficeGoogleUrls();
    toast.success(t('rep.modal.gmb.toast.text_copied_open_google'), { duration: 6000 });
    window.open(searchManageUrl, '_blank');
  };

  // Handler: Generate Post with Gemini
  const handleGeneratePost = async (customTopic) => {
    const topicToUse = typeof customTopic === 'string' ? customTopic : postTopic;
    setGeneratingPost(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/posts/generate?office_key=${encodeURIComponent(selectedOfficeKey)}`, {
        topic: topicToUse || undefined
      });
      if (res.data) {
        if (res.data.topic) {
          setPostTopic(res.data.topic);
        } else if (!topicToUse && res.data.headline) {
          setPostTopic(res.data.headline);
        }
        setPostSummary(res.data.summary || '');
        setPostCtaType(res.data.cta_type || 'BOOK');
        setPostCtaUrl(res.data.cta_url || 'https://fitenkolaw.com/consultation');
        if (res.data.media_url) {
          const matching = availablePhotos.find(p => p.url === res.data.media_url);
          if (matching) {
            setSelectedPhoto(matching);
          } else {
            setSelectedPhoto({
              url: res.data.media_url,
              label: res.data.media_caption || 'Attorney Photo (Media Vault)',
              category: 'portrait',
              filename: 'vault_photo.jpg'
            });
          }
        } else if (availablePhotos.length > 0 && !selectedPhoto) {
          const defaultPhoto = availablePhotos.find(p => p.category === 'portrait' || p.category === 'action') || availablePhotos[0];
          setSelectedPhoto(defaultPhoto);
        }
        toast.success(t('rep.modal.gmb.toast.draft_generated'));
      }
    } catch (err) {
      // 🔴 Здесь на ОТКАЗЕ генератора подставлялся готовый текст поста от
      //    имени фирмы и адвоката — и печаталось «draft prepared», как будто
      //    его написал генератор. Черновик, написанный вёрсткой, публикуется
      //    от имени фирмы так же, как настоящий.
      toast.error(t('rep.modal.gmb.toast.draft_failed', { reason: (err && err.message) || t('rep.modal.gmb.status.reason_not_specified') }));
    } finally {
      setGeneratingPost(false);
    }
  };

  // Handler: Publish Google Post
  const handlePublishPost = async () => {
    if (!postSummary.trim()) {
      toast.error(t('rep.modal.gmb.toast.post_empty'));
      return;
    }
    setPublishingPost(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/posts`, {
        summary: postSummary,
        cta_type: postCtaType,
        cta_url: postCtaUrl,
        media_url: selectedPhoto ? selectedPhoto.url : null,
        ai_topic: postTopic || 'General Immigration Counsel',
        office_key: selectedOfficeKey
      });
      if (res.data?.live_published) {
        toast.success(t('rep.modal.gmb.toast.post_live'));
      } else {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(postSummary);
        }
        toast.success(t('rep.modal.gmb.toast.post_copied_open'), {
          duration: 7000
        });
      }
      setPosts(prev => [
        {
          id: res.data?.post_id || String(Date.now()),
          summary: postSummary,
          cta_type: postCtaType,
          cta_url: postCtaUrl,
          status: res.data?.live_published ? 'published' : (res.data?.status || 'needs_review'),
          published_at: res.data?.live_published ? new Date().toISOString() : null,
          created_at: new Date().toISOString()
        },
        ...prev
      ]);
      setPostSummary('');
    } catch (err) {
      // 🔴 Здесь печаталось «Post saved to listing history» на ОТКАЗЕ записи:
      //    пост никуда не сохранён, а текст из поля ещё и стирался.
      toast.error(t('rep.modal.gmb.toast.post_failed', { reason: (err && err.message) || t('rep.modal.gmb.status.reason_not_specified') }));
    } finally {
      setPublishingPost(false);
    }
  };

  // Handler: Approve Google Post
  const handleApprovePost = async (postId) => {
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/posts/${postId}/approve`);
      toast.success(t('rep.modal.gmb.toast.post_marked_live') || 'Post approved and sent to Google Maps');
      setPosts(prev =>
        prev.map(p => p.id === postId ? { ...p, status: res.data?.status || 'published', published_at: new Date().toISOString() } : p)
      );
    } catch (err) {
      toast.error(t('rep.modal.gmb.toast.mark_failed', { reason: (err && err.response && err.response.data && err.response.data.detail) || (err && err.message) || t('rep.modal.gmb.status.reason_not_specified') }));
    }
  };

  // Handler: Draft AI Review Reply
  const handleDraftReply = async (review) => {
    setReplyingReviewId(review.id);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/reviews/${review.id}/draft-reply?office_key=${encodeURIComponent(selectedOfficeKey)}`);
      if (res.data?.suggested_reply) {
        setReplyDrafts(prev => ({ ...prev, [review.id]: res.data.suggested_reply }));
      }
    } catch (err) {
      // 🔴 На отказе генератора здесь подставлялся готовый ответ с подписью
      //    адвоката. Публичный ответ от имени адвоката, написанный вёрсткой, —
      //    утверждение от лица человека, который его не писал.
      toast.error(t('rep.modal.gmb.toast.reply_draft_failed', { reason: (err && err.message) || t('rep.modal.gmb.status.reason_not_specified') }));
    } finally {
      setReplyingReviewId(null);
    }
  };

  // Handler: Submit Review Reply
  const handleSubmitReply = async (review) => {
    const text = replyDrafts[review.id];
    if (!text) return;
    setSubmittingReply(true);
    try {
      await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/reviews/${review.id}/reply?office_key=${encodeURIComponent(selectedOfficeKey)}`, {
        reply_text: text
      });
      toast.success(t('rep.modal.gmb.toast.reply_live'));
      setReviews(prev =>
        prev.map(r => r.id === review.id ? { ...r, reply_text: text, reply_status: 'published' } : r)
      );
    } catch (err) {
      // 🔴 Здесь ответ помечался опубликованным на отказе публикации: человек
      //    считал, что клиенту ответили, а ответа не было.
      toast.error(t('rep.modal.gmb.toast.reply_failed', { reason: (err && err.message) || t('rep.modal.gmb.status.reason_not_specified') }));
    } finally {
      setSubmittingReply(false);
    }
  };

  // Handler: Save Autopilot Settings
  const handleSaveAutopilot = async () => {
    try {
      await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/autopilot?office_key=${encodeURIComponent(selectedOfficeKey)}`, {
        autopilot_enabled: autopilotEnabled,
        autopilot_weekly_post: autopilotWeeklyPost,
        autopilot_review_auto_reply: autopilotReviewReply,
        post_day: autopilotPostDay
      });
      toast.success(t('rep.modal.gmb.toast.autopilot_saved'));
    } catch (err) {
      toast.error(t('rep.modal.gmb.toast.autopilot_failed', { reason: (err && err.message) || t('rep.modal.gmb.status.reason_not_specified') }));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs">
      <div className="bg-[#FCFBF8] border border-[#E5E1D6] rounded-2xl w-full max-w-5xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        
        {/* HEADER */}
        <div className="px-6 py-5 border-b border-[#F1EEE4] bg-white flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#FAF4E5] border border-[#E5D7B5] flex items-center justify-center text-[#C8A653]">
              <MapPin className="w-5 h-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h2 className="text-lg font-serif font-bold text-[#20231F]">
                  {t('rep.modal.gmb.title')}
                </h2>
                <select
                  data-testid="gmb-office-select"
                  aria-label="office-select"
                  value={selectedOfficeKey}
                  onChange={(e) => setSelectedOfficeKey(e.target.value)}
                  className="text-xs bg-[#FAF4E5] border border-[#E5D7B5] rounded px-2 py-0.5 font-bold text-[#A97F2E] cursor-pointer"
                >
                  <option value="coral-springs">Coral Springs</option>
                  <option value="hallandale-beach">Hallandale Beach</option>
                </select>
                <span className="text-[10px] uppercase font-bold px-2 py-0.5 rounded bg-[#FAF4E5] text-[#A97F2E]">
                  {office.badge || (office.is_main ? t('rep.modal.gmb.main_canon') : t('rep.modal.gmb.branch'))}
                </span>
              </div>
              <div className="text-xs text-[#687077] flex items-center gap-2 mt-0.5">
                <span>{office.address}</span>
                <span>·</span>
                {/* 🔴 Здесь обе ветки утверждали синхронизацию: «нет отметки
                    времени» печаталось как «live». Теперь печатается САМ
                    момент, а его отсутствие — словами. */}
                <span className="text-[#687077] font-medium flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  {locationData?.last_synced_at
                    ? t('rep.modal.gmb.synced_at', { date: locationData.last_synced_at })
                    : t('rep.modal.gmb.not_synced')}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              data-knopka="sync"
              onClick={handleSyncNow}
              disabled={knopkaVyklyuchena}
              className="h-8 px-3 inline-flex items-center gap-1.5 text-xs font-semibold rounded-lg bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F8F7F2] transition-colors cursor-pointer shadow-2xs disabled:opacity-50 disabled:cursor-not-allowed"
              title={podskazkaSync}
            >
              <RefreshCw className={`w-3.5 h-3.5 text-[#C8A653] ${syncing ? 'animate-spin' : ''}`} />
              <span>{syncing ? t('rep.modal.gmb.btn_syncing') : t('rep.modal.gmb.btn_sync_now')}</span>
            </button>

            {office.gmb_url && (
              <a
                href={office.gmb_url}
                target="_blank"
                rel="noopener noreferrer"
                className="h-8 px-3 inline-flex items-center gap-1.5 text-xs font-semibold rounded-lg bg-[#20231F] text-white hover:bg-[#343833] transition-colors cursor-pointer shadow-2xs"
              >
                <ExternalLink className="w-3.5 h-3.5 text-[#C8A653]" />
                <span>{t('rep.modal.gmb.btn_open_maps')}</span>
              </a>
            )}

            <button
              onClick={onClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-[#687077] hover:text-[#20231F] hover:bg-[#F1EEE4] transition-colors cursor-pointer"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* NAVIGATION TABS */}
        <div className="px-6 py-2 bg-[#F8F7F2] border-b border-[#E5E1D6] flex items-center gap-2 overflow-x-auto text-xs font-medium">
          <button
            onClick={() => setActiveTab('audit')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'audit' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <ShieldCheck className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>{t('rep.modal.gmb.tab_audit')}</span>
            {latestAudit && (
              <span className="text-[10px] font-bold px-1.5 py-0.2 rounded bg-[#C8A653] text-[#20231F]">
                {pokazatVelichinu(latestAudit.score)}/100
              </span>
            )}
          </button>

          <button
            onClick={() => setActiveTab('posts')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'posts' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <Send className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>{t('rep.modal.gmb.tab_posts')}</span>
          </button>

          <button
            onClick={() => setActiveTab('reviews')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'reviews' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <MessageSquare className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>{t('rep.modal.gmb.tab_reviews')}</span>
            <span className="text-[10px] font-bold px-1.5 py-0.2 rounded bg-[#FAF4E5] text-[#A97F2E]">
              {reviews.length}
            </span>
          </button>

          <button
            onClick={() => setActiveTab('services')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'services' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <Briefcase className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>{t('rep.modal.gmb.tab_services')}</span>
          </button>

          <button
            onClick={() => setActiveTab('autopilot')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'autopilot' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <Sliders className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>{t('rep.modal.gmb.tab_autopilot')}</span>
          </button>
        </div>

        {/* MODAL BODY */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6">

          {/* СОСТОЯНИЕ ЗАПИСИ И ПОКАЗАТЕЛИ — ВИДНЫ НА ЛЮБОЙ ВКЛАДКЕ */}
          <PlashkaSostoyaniya otkazZagruzki={otkazZagruzki} location={locationData} />

          <div className="bg-white border border-[#E5E1D6] rounded-2xl p-5 shadow-xs">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-serif font-bold text-[#20231F]">{t('rep.modal.gmb.metrics_30d_title')}</h3>
              <span className="text-[10px] text-[#687077]">
                {t('rep.modal.gmb.metrics_source_hint')}
              </span>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {POKAZATELI.map(([kluch, podpis]) => (
                <div key={kluch} className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                  <div className="text-[10px] uppercase font-bold text-[#687077]">{podpis}</div>
                  <div
                    data-metrika={kluch}
                    className="text-lg font-serif font-bold text-[#20231F] mt-0.5"
                  >
                    {pokazatVelichinu(locationData ? locationData[kluch] : null)}
                  </div>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-3">
              <div className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                <div className="text-[10px] uppercase font-bold text-[#687077]">{t('rep.modal.gmb.metric.rating')}</div>
                <div data-metrika="rating" className="text-lg font-serif font-bold text-[#20231F] mt-0.5">
                  {pokazatVelichinu(locationData ? locationData.rating : null)}
                </div>
              </div>
              <div className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                <div className="text-[10px] uppercase font-bold text-[#687077]">{t('rep.modal.gmb.metric.reviews')}</div>
                <div data-metrika="reviews_count" className="text-lg font-serif font-bold text-[#20231F] mt-0.5">
                  {pokazatVelichinu(locationData ? locationData.reviews_count : null)}
                </div>
              </div>
              <div className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                <div className="text-[10px] uppercase font-bold text-[#687077]">{t('rep.modal.gmb.metric.audit_score')}</div>
                <div data-metrika="latest_audit_score" className="text-lg font-serif font-bold text-[#20231F] mt-0.5">
                  {pokazatVelichinu(locationData ? locationData.latest_audit_score : null)}
                </div>
              </div>
            </div>
          </div>

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 1: AI 7-FACTOR AUDIT                                      */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'audit' && (
            <div className="space-y-6">
              {/* Score banner */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 flex flex-col md:flex-row md:items-center justify-between gap-6 shadow-xs">
                <div className="flex items-center gap-5">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-20 h-20 rounded-2xl bg-[#FCFBF8] border-2 border-[#C8A653] flex flex-col items-center justify-center text-center shadow-xs">
                      <span className="text-3xl font-serif font-bold text-[#20231F]">
                        {pokazatVelichinu(latestAudit?.score)}
                      </span>
                      {/* 🔴 «Grade —» печаталось и тогда, когда аудита не было
                          вовсе: подпись под прочерком выглядит как разряд, в
                          который запись попала. Нет записи — нет и грейда. */}
                      <span className="text-[10px] uppercase font-bold text-[#A97F2E]">
                        {latestAudit ? `Grade ${pokazatVelichinu(latestAudit.grade)}` : t('rep.modal.gmb.audit.no_measurement')}
                      </span>
                    </div>
                    {/* 🔴 МОМЕНТ ЗАМЕРА РЯДОМ С ЧИСЛОМ (quick-260917-1bw). Число
                        без времени читается как сегодняшнее: оценка годичной
                        давности выглядит на экране так же, как снятая минуту
                        назад. Нет записи — ничего не печатается (рядом уже
                        стоит «Аудит не проводился: сводки нет»); есть запись
                        без момента — так и сказано, а не подставлено «сейчас».
                        🔴 Момент печатается ДОСЛОВНО, как его назвал сервер, и
                        НЕ пересчитывается в «N дней назад»: относительный срок
                        лжёт в момент чтения, а пересчёт без часового пояса был
                        бы новым утверждением о времени. */}
                    {latestAudit && (
                      <span data-audit="moment" className="text-[10px] text-[#687077] text-center leading-tight max-w-[7rem]">
                        {latestAudit.izmereno_v
                          ? t('rep.modal.gmb.audit.measured_at', { date: latestAudit.izmereno_v })
                          : t('rep.modal.gmb.audit.time_unknown')}
                      </span>
                    )}
                  </div>
                  <div>
                    {/* 🔴 Подпись о модели печаталась ВСЕГДА, в том числе когда
                        модель не спрашивали ни разу. «Аудит сделан Gemini 2.5» —
                        такое же утверждение о мире, как и число, и без записи
                        оно ложно. Печатается то, что ЗАПИСАНО в строке журнала,
                        а не литерал в вёрстке. */}
                    {latestAudit && (
                      <div data-audit="model" className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[10px] font-bold bg-[#FAF4E5] text-[#A97F2E] mb-1">
                        <Sparkles className="w-3 h-3 text-[#C8A653]" />
                        <span>{t('rep.modal.gmb.audit.audited_by_model', { model: latestAudit.model_used || t('rep.modal.gmb.audit.model_not_named') })}</span>
                      </div>
                    )}
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      {t('rep.modal.gmb.audit.health_score_title')}
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5 max-w-lg leading-relaxed">
                      {/* 🔴 Здесь стоял готовый вывод аудита — с именем адвоката и
                          номером Bar — который печатался, КОГДА АУДИТА НЕ БЫЛО. */}
                      {latestAudit?.summary || t('rep.modal.gmb.audit.no_audit_summary')}
                    </p>
                  </div>
                </div>

                <div className="flex flex-col items-end gap-1">
                  <button
                    disabled={true}
                    title={t('rep.modal.gmb.audit.repeat_disabled_hint')}
                    className="h-9 px-4 rounded-xl text-xs font-semibold bg-[#20231F] text-white opacity-50 cursor-not-allowed inline-flex items-center gap-2 shadow-xs"
                  >
                    <RefreshCw className="w-3.5 h-3.5 text-[#C8A653]" />
                    <span>{t('rep.modal.gmb.audit.btn_repeat')}</span>
                  </button>
                  <span className="text-[10px] text-[#A97F2E] font-medium">
                    {t('rep.modal.gmb.audit.repeat_disabled_hint')}
                  </span>
                </div>
              </div>

              {/* 7 Factors Breakdown */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                <h3 className="text-sm font-serif font-bold text-[#20231F] mb-4">
                  {t('rep.modal.gmb.audit.factors_title')}
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {[
                    /* 🔴 УМОЛЧАНИЙ НЕТ. Здесь стояли семь правдоподобных процентов и
                       подписи, УТВЕРЖДАВШИЕ проверку («matched 100%», «verified logo
                       present»), которой никто не делал. Фактор не измерен — прочерк. */
                    { label: 'NAP & Bar Consistency', score: latestAudit?.factors?.nap_consistency, desc: t('rep.modal.gmb.audit.factor.nap_consistency') },
                    { label: 'Primary Categories', score: latestAudit?.factors?.categories, desc: t('rep.modal.gmb.audit.factor.categories') },
                    { label: 'Services Catalog', score: latestAudit?.factors?.services_catalog, desc: t('rep.modal.gmb.audit.factor.services_catalog') },
                    { label: 'Visual Media & Photos', score: latestAudit?.factors?.visual_media, desc: t('rep.modal.gmb.audit.factor.visual_media') },
                    { label: 'Google Posts Cadence', score: latestAudit?.factors?.posts_cadence, desc: t('rep.modal.gmb.audit.factor.posts_cadence') },
                    { label: 'Review Velocity & Sentiment', score: latestAudit?.factors?.review_velocity, desc: t('rep.modal.gmb.audit.factor.review_velocity') },
                    { label: 'Local Geo Prominence', score: latestAudit?.factors?.local_prominence, desc: t('rep.modal.gmb.audit.factor.local_prominence') }
                  ].map((f, i) => (
                    <div key={i} className="p-4 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8] space-y-2">
                      <div className="flex items-center justify-between">
                        <span className="text-xs font-bold text-[#20231F]">{f.label}</span>
                        <span className="text-xs font-serif font-bold text-[#0B8B5E]">
                          {f.score === null || f.score === undefined ? '—' : `${f.score}%`}
                        </span>
                      </div>
                      {/* Полоса рисуется ТОЛЬКО по измеренной величине: полоса
                          нулевой длины на месте «не измерено» читалась бы как ноль. */}
                      {f.score === null || f.score === undefined ? null : (
                        <div className="w-full h-1.5 bg-[#F1EEE4] rounded-full overflow-hidden">
                          <div
                            className={`h-full rounded-full ${f.score >= 90 ? 'bg-[#0B8B5E]' : 'bg-[#C8A653]'}`}
                            style={{ width: `${f.score}%` }}
                          />
                        </div>
                      )}
                      <p className="text-[11px] text-[#687077] leading-tight">{f.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Actionable Fixes */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <h3 className="text-sm font-serif font-bold text-[#20231F]">
                  {t('rep.modal.gmb.audit.fixes_title')}
                </h3>

                <div className="space-y-3">
                  {(latestAudit?.gaps || []).map((gap, i) => (
                    <div key={i} className="p-3.5 rounded-xl bg-[#FCFBF8] border border-[#F1EEE4] flex items-start gap-3 text-xs">
                      <AlertTriangle className="w-4 h-4 text-[#C8A653] shrink-0 mt-0.5" />
                      <span className="text-[#20231F] flex-1 leading-relaxed">{gap}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 2: GOOGLE POSTS (AUTO-PILOT & GENERATOR)                  */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'posts' && (
            <div className="space-y-6">
              {/* Google OAuth & GBP Direct API Status Banner */}
              <div className={`p-4 rounded-xl border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 ${
                authStatus.has_gmb_scope
                  ? 'bg-[#E6F6EE] border-[#B7E5D0] text-[#0B8B5E]'
                  : 'bg-[#FAF4E5] border-[#E5D7B5] text-[#20231F]'
              }`}>
                <div className="flex items-center gap-2.5">
                  <Bot className={`w-4 h-4 shrink-0 ${authStatus.has_gmb_scope ? 'text-[#0B8B5E]' : 'text-[#C8A653]'}`} />
                  <div className="text-xs leading-relaxed">
                    <span className="font-bold">
                      {authStatus.has_gmb_scope
                        ? t('rep.modal.gmb.posts.api_connected')
                        : t('rep.modal.gmb.posts.api_status')}
                    </span>
                    <p className="text-[11px] text-[#687077] mt-0.5">
                      {authStatus.has_gmb_scope
                        ? t('rep.modal.gmb.posts.api_authorized_for', { email: authStatus.email || 'fitenkolaw@gmail.com' })
                        : t('rep.modal.gmb.posts.api_link_hint', { email: authStatus.email || 'fitenkolaw@gmail.com' })}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 shrink-0">
                  {!authStatus.has_gmb_scope && (
                    <button
                      type="button"
                      onClick={handleConnectGoogle}
                      disabled={connectingGoogle}
                      className="h-8 px-3.5 rounded-lg text-xs font-semibold bg-[#20231F] text-[#C8A653] border border-[#C8A653]/30 hover:bg-[#343833] inline-flex items-center gap-1.5 transition-colors cursor-pointer shadow-xs"
                    >
                      <ExternalLink className="w-3.5 h-3.5 text-[#C8A653]" />
                      <span>{connectingGoogle ? t('rep.modal.gmb.posts.btn_connecting') : t('rep.modal.gmb.posts.btn_connect_auto')}</span>
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={() => window.open(getOfficeGoogleUrls().searchManageUrl, '_blank')}
                    className="h-8 px-3 rounded-lg text-xs font-semibold bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F9F7F1] inline-flex items-center gap-1.5 transition-colors cursor-pointer"
                    title="Open Google Profile directly in Google Search"
                  >
                    <ExternalLink className="w-3.5 h-3.5 text-[#687077]" />
                    <span>{t('rep.modal.gmb.posts.btn_open_profile')}</span>
                  </button>
                </div>
              </div>

              {/* Post Creator Box */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <div className="flex items-center justify-between pb-3 border-b border-[#F1EEE4]">
                  <div>
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      {t('rep.modal.gmb.posts.create_title')}
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5">
                      {t('rep.modal.gmb.posts.create_subtitle', { firm: office.company_name, city: office.location_name?.split(',')[0] || '' })}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleGeneratePost()}
                    disabled={generatingPost}
                    className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1.5 transition-colors cursor-pointer"
                  >
                    <Sparkles className={`w-3.5 h-3.5 text-[#C8A653] ${generatingPost ? 'animate-spin' : ''}`} />
                    <span>{generatingPost ? t('rep.modal.gmb.posts.btn_generating') : t('rep.modal.gmb.posts.btn_generate')}</span>
                  </button>
                </div>

                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-[#20231F] mb-1">
                      {t('rep.modal.gmb.posts.topic_label')}
                    </label>
                    <input
                      type="text"
                      value={postTopic}
                      onChange={e => setPostTopic(e.target.value)}
                      placeholder={t('rep.modal.gmb.posts.topic_placeholder')}
                      className="w-full h-9 px-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                    />

                    {/* Quick-Pick Suggested Topics */}
                    <div className="flex flex-wrap items-center gap-1.5 pt-2">
                      <span className="text-[11px] font-medium text-[#687077]">{t('rep.modal.gmb.posts.suggested_label')}</span>
                      {[
                        'USCIS Visa Bulletin & Priority Dates',
                        'EB-1A Extraordinary Ability Strategy',
                        'EB-2 NIW for STEM & AI Founders',
                        'Affirmative Asylum & Work Authorization',
                        'Family Green Card & Concurrent Filing'
                      ].map((suggested, sIdx) => (
                        <button
                          key={sIdx}
                          type="button"
                          onClick={() => {
                            setPostTopic(suggested);
                            handleGeneratePost(suggested);
                          }}
                          className="text-[10px] px-2 py-0.5 rounded-md bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] transition-colors cursor-pointer"
                        >
                          ⚡ {suggested}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-[#20231F] mb-1">
                      {t('rep.modal.gmb.posts.content_label')}
                    </label>
                    <textarea
                      rows={5}
                      value={postSummary}
                      onChange={e => setPostSummary(e.target.value)}
                      placeholder={t('rep.modal.gmb.posts.content_placeholder')}
                      className="w-full p-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                    />
                  </div>

                  {/* ───────────────────────────────────────────────────────────── */}
                  {/* ATTORNEY PHOTO VAULT / MEDIA PICKER                          */}
                  {/* ───────────────────────────────────────────────────────────── */}
                  <div className="pt-1">
                    <div className="flex items-center justify-between mb-2">
                      <label className="flex items-center gap-1.5 text-xs font-semibold text-[#20231F]">
                        <Camera className="w-3.5 h-3.5 text-[#C8A653]" />
                        <span>{t('rep.modal.gmb.posts.media_label')}</span>
                      </label>
                      <div className="flex items-center gap-2">
                        <label className="h-7 px-2.5 rounded-lg text-xs font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1 cursor-pointer transition-colors shadow-2xs">
                          <Upload className="w-3 h-3 text-[#C8A653]" />
                          <span>{uploadingPhotos ? t('rep.modal.gmb.posts.btn_uploading') : t('rep.modal.gmb.posts.btn_upload_bulk')}</span>
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleBulkUploadPhotos}
                            className="hidden"
                            disabled={uploadingPhotos}
                          />
                        </label>
                        <button
                          type="button"
                          onClick={() => setShowPhotoVault(!showPhotoVault)}
                          className="text-xs font-semibold text-[#C8A653] hover:underline cursor-pointer"
                        >
                          {showPhotoVault ? t('rep.modal.gmb.posts.btn_collapse_gallery') : t('rep.modal.gmb.posts.btn_choose_gallery', { count: availablePhotos.length })}
                        </button>
                      </div>
                    </div>

                    {/* Active Selected Photo Preview Banner */}
                    {selectedPhoto ? (
                      <div className="flex items-center justify-between p-3 rounded-xl border border-[#E5E1D6] bg-[#FCFBF8]">
                        <div className="flex items-center gap-3">
                          <img
                            src={selectedPhoto.url}
                            alt={selectedPhoto.label}
                            className="w-14 h-14 object-cover rounded-lg border border-[#E5E1D6] shadow-2xs"
                          />
                          <div>
                            <div className="text-xs font-bold text-[#20231F] flex items-center gap-1.5">
                              <span>{selectedPhoto.label}</span>
                              <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-[#FAF4E5] text-[#A97F2E] uppercase">
                                {selectedPhoto.category}
                              </span>
                            </div>
                            <p className="text-[11px] text-[#687077] truncate max-w-sm mt-0.5">
                              {selectedPhoto.filename}
                            </p>
                            <span className="text-[10px] text-[#0B8B5E] font-medium inline-flex items-center gap-1 mt-0.5">
                              <CheckCircle2 className="w-2.5 h-2.5" />
                              {t('rep.modal.gmb.posts.will_attach_hint')}
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => {
                              const randomIdx = Math.floor(Math.random() * availablePhotos.length);
                              setSelectedPhoto(availablePhotos[randomIdx]);
                              toast.success(t('rep.modal.gmb.toast.random_photo_picked'));
                            }}
                            className="h-7 px-2 text-[11px] font-medium text-[#687077] hover:text-[#20231F] border border-[#E5E1D6] rounded-lg hover:bg-white"
                          >
                            {t('rep.modal.gmb.posts.btn_random_photo')}
                          </button>
                          <button
                            type="button"
                            onClick={() => setSelectedPhoto(null)}
                            className="h-7 px-2 text-[11px] font-medium text-[#C93B2B] hover:bg-[#FDF2F2] rounded-lg border border-[#FAD2CF]"
                          >
                            {t('rep.modal.gmb.posts.btn_remove_photo')}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="p-3 text-center border border-dashed border-[#D3CEBF] rounded-xl bg-[#FAF9F5]">
                        <p className="text-xs text-[#687077]">
                          {t('rep.modal.gmb.posts.no_photo_attached')} <button type="button" onClick={() => setShowPhotoVault(true)} className="text-[#C8A653] font-semibold underline">{t('rep.modal.gmb.posts.choose_from_gallery_link')}</button> {t('rep.modal.gmb.posts.or_upload_new')}
                        </p>
                      </div>
                    )}

                    {/* Expandable Gallery Grid */}
                    {showPhotoVault && (
                      <div className="mt-3 p-4 rounded-xl border border-[#E5D7B5] bg-[#FFFDF9] space-y-3 shadow-xs">
                        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-[#F1E8D2] pb-2.5">
                          <div className="flex items-center gap-1.5 text-xs font-semibold text-[#20231F]">
                            <ImageIcon className="w-3.5 h-3.5 text-[#C8A653]" />
                            <span>{t('rep.modal.gmb.posts.media_library_title', { count: availablePhotos.length })}</span>
                          </div>
                          <div className="flex items-center gap-1 text-[11px]">
                            {['all', 'portrait', 'action', 'credentials', 'office'].map((cat) => (
                              <button
                                key={cat}
                                type="button"
                                onClick={() => setPhotoCategory(cat)}
                                className={`px-2 py-0.5 rounded-md font-medium capitalize cursor-pointer transition-colors ${
                                  photoCategory === cat
                                    ? 'bg-[#20231F] text-white'
                                    : 'bg-white text-[#687077] border border-[#E5E1D6] hover:text-[#20231F]'
                                }`}
                              >
                                {cat === 'all' ? t('rep.modal.gmb.posts.category_all') : cat}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2.5 max-h-56 overflow-y-auto pr-1">
                          {availablePhotos
                            .filter(p => photoCategory === 'all' || p.category === photoCategory)
                            .map((photo, idx) => {
                              const isSelected = selectedPhoto?.filename === photo.filename;
                              return (
                                <div
                                  key={idx}
                                  onClick={() => setSelectedPhoto(photo)}
                                  className={`group relative rounded-lg overflow-hidden border-2 cursor-pointer transition-all aspect-square bg-gray-100 ${
                                    isSelected
                                      ? 'border-[#C8A653] ring-2 ring-[#C8A653]/30 scale-95'
                                      : 'border-transparent hover:border-[#D3CEBF]'
                                  }`}
                                >
                                  <img
                                    src={photo.url}
                                    alt={photo.label}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                                  />
                                  {isSelected && (
                                    <div className="absolute top-1 right-1 bg-[#C8A653] text-white p-0.5 rounded-full shadow-xs">
                                      <Check className="w-3 h-3" />
                                    </div>
                                  )}
                                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-1">
                                    <p className="text-[9px] text-white font-medium truncate">
                                      {photo.label}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">
                    <div>
                      <label className="block text-xs font-semibold text-[#20231F] mb-1">
                        {t('rep.modal.gmb.posts.cta_button_label')}
                      </label>
                      <select
                        value={postCtaType}
                        onChange={e => setPostCtaType(e.target.value)}
                        className="w-full h-9 px-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                      >
                        <option value="BOOK">{t('rep.modal.gmb.posts.cta_book')}</option>
                        {/* 🔴 Номер телефона фирмы в вёрстке был ТРЕТЬЕЙ копией канона.
                            Номер берёт Google из самой записи. */}
                        <option value="CALL">{t('rep.modal.gmb.posts.cta_call')}</option>
                        <option value="LEARN_MORE">{t('rep.modal.gmb.posts.cta_learn_more')}</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-semibold text-[#20231F] mb-1">
                        {t('rep.modal.gmb.posts.cta_url_label')}
                      </label>
                      <input
                        type="text"
                        value={postCtaUrl}
                        onChange={e => setPostCtaUrl(e.target.value)}
                        className="w-full h-9 px-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                      />
                    </div>
                  </div>

                  <div className="flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-[#F1EEE4]">
                    <div>
                      {!selectedOfficeKey && (
                        <span className="text-xs text-[#DC2626] font-medium">
                          {t('rep.gmb.select_office_hint')}
                        </span>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => handleCopyAndOpenGoogle()}
                        disabled={!postSummary.trim() || !selectedOfficeKey}
                        className="h-9 px-4 rounded-xl text-xs font-semibold bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F9F7F1] disabled:opacity-50 inline-flex items-center gap-2 transition-colors cursor-pointer shadow-xs"
                        title={!selectedOfficeKey ? t('rep.gmb.select_office_hint') : t('rep.modal.gmb.posts.btn_copy_open')}
                      >
                        <Copy className="w-3.5 h-3.5 text-[#C8A653]" />
                        <span>{t('rep.modal.gmb.posts.btn_copy_open')}</span>
                      </button>

                      <button
                        type="button"
                        onClick={handlePublishPost}
                        disabled={publishingPost || !postSummary.trim() || !selectedOfficeKey}
                        className="h-9 px-5 rounded-xl text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] disabled:opacity-50 inline-flex items-center gap-2 transition-colors cursor-pointer shadow-xs"
                        title={!selectedOfficeKey ? t('rep.gmb.select_office_hint') : undefined}
                      >
                        <Send className="w-3.5 h-3.5 text-[#C8A653]" />
                        <span>{publishingPost ? t('rep.modal.gmb.posts.btn_publishing') : t('rep.modal.gmb.posts.btn_publish')}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* History of Posts */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <h3 className="text-sm font-serif font-bold text-[#20231F]">
                  {t('rep.modal.gmb.posts.recent_title', { count: posts.length })}
                </h3>

                <div className="divide-y divide-[#F1EEE4]">
                  {posts.map((post, idx) => {
                    const isLive = post.status === 'published';
                    return (
                      <div key={idx} className="py-4 space-y-2.5">
                        <div className="flex flex-wrap items-center justify-between gap-2 text-xs">
                          <span className="font-semibold text-[#20231F]">
                            {post.cta_type} · {new Date(post.created_at).toLocaleDateString()}
                          </span>
                          {isLive ? (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded bg-[#E6F6EE] text-[#0B8B5E] border border-[#B7E5D0]">
                              <CheckCircle2 className="w-3 h-3" />
                              <span>{t('rep.modal.gmb.posts.badge_live')}</span>
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded bg-[#FFF4E5] text-[#B76E00] border border-[#FFE2B2]">
                              <AlertTriangle className="w-3 h-3 text-[#B76E00]" />
                              <span>{t('rep.modal.gmb.posts.badge_saved_os')}</span>
                            </span>
                          )}
                        </div>
                        <p className="text-xs text-[#687077] leading-relaxed">{post.summary}</p>
                        
                        {!isLive && (
                          <div className="flex flex-wrap items-center justify-between gap-2 pt-2 border-t border-[#F8F6F0]">
                            <span className="text-[11px] text-[#A97F2E]">
                              {t('rep.modal.gmb.posts.saved_os_hint')}
                            </span>
                            <div className="flex items-center gap-2">
                              {!authStatus.has_gmb_scope && (
                                <button
                                  type="button"
                                  onClick={handleConnectGoogle}
                                  disabled={connectingGoogle}
                                  className="h-7 px-2.5 rounded-lg text-[11px] font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1 transition-colors cursor-pointer"
                                  title="Авторизовать Google для прямой публикации"
                                >
                                  <Bot className="w-3 h-3 text-[#C8A653]" />
                                  <span>{t('rep.modal.gmb.posts.btn_auto_pub')}</span>
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={() => handleCopyAndOpenGoogle(post.summary)}
                                className="h-7 px-3 rounded-lg text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] inline-flex items-center gap-1.5 transition-colors cursor-pointer shadow-xs"
                              >
                                <Copy className="w-3 h-3 text-[#C8A653]" />
                                <span>{t('rep.modal.gmb.posts.btn_copy_open')}</span>
                              </button>
                              <button
                                type="button"
                                onClick={() => handleApprovePost(post.id)}
                                className="h-7 px-2.5 rounded-lg text-xs font-semibold bg-white border border-[#B7E5D0] text-[#0B8B5E] hover:bg-[#E6F6EE] inline-flex items-center gap-1 transition-colors cursor-pointer shadow-2xs"
                                title="Подтвердить, что пост опубликован на Картах"
                              >
                                <CheckCircle2 className="w-3 h-3 text-[#0B8B5E]" />
                                <span>{t('rep.modal.gmb.posts.btn_published_mark')}</span>
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {posts.length === 0 && (
                    <div className="py-8 text-center text-xs text-[#687077]">
                      {t('rep.modal.gmb.posts.no_posts_empty')}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 3: REVIEWS & AI REPLIES                                   */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'reviews' && (
            <div className="space-y-6">
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                <div className="flex items-center justify-between pb-4 border-b border-[#F1EEE4] mb-4">
                  <div>
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      {t('rep.modal.gmb.reviews.title', { count: reviews.length })}
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5">
                      {/* 🔴 Утверждение «все ответы подписаны …» было ложным по
                          построению: подпись ставится только если её передали. */}
                      {t('rep.modal.gmb.reviews.signature_hint')}
                    </p>
                  </div>
                  <span className="text-xs font-semibold text-[#0B8B5E] bg-[#E6F6EE] px-2.5 py-1 rounded-md">
                    {t('rep.modal.gmb.reviews.coverage')}
                  </span>
                </div>

                <div className="space-y-4">
                  {reviews.map((rev) => (
                    <div key={rev.id} className="p-5 rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] space-y-3">
                      <div className="flex items-start justify-between">
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="text-xs font-bold text-[#20231F]">{rev.reviewer_name}</span>
                            <span className="text-xs text-[#C8A653] font-bold">
                              {'★'.repeat(rev.star_rating)}
                            </span>
                          </div>
                          <span className="text-[10px] text-[#687077]">
                            {new Date(rev.review_date).toLocaleDateString()}
                          </span>
                        </div>
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded ${
                          rev.reply_text ? 'bg-[#E6F6EE] text-[#0B8B5E]' : 'bg-[#FAF4E5] text-[#A97F2E]'
                        }`}>
                          {rev.reply_text ? t('rep.modal.gmb.reviews.badge_replied') : t('rep.modal.gmb.reviews.badge_pending')}
                        </span>
                      </div>

                      <p className="text-xs text-[#20231F] leading-relaxed italic">
                        "{rev.comment}"
                      </p>

                      {/* Official Reply Box */}
                      {rev.reply_text ? (
                        <div className="p-3.5 rounded-xl bg-white border border-[#E5E1D6] text-xs space-y-1">
                          <div className="font-semibold text-[#C8A653] flex items-center gap-1.5">
                            <Check className="w-3.5 h-3.5 text-[#0B8B5E]" />
                            <span>{rev.reply_signed_by ? t('rep.modal.gmb.reviews.official_reply_by', { author: rev.reply_signed_by }) : t('rep.modal.gmb.reviews.official_reply')}</span>
                          </div>
                          <p className="text-[#687077] leading-relaxed">{rev.reply_text}</p>
                        </div>
                      ) : (
                        <div className="pt-2 border-t border-[#F1EEE4] space-y-2">
                          {replyDrafts[rev.id] ? (
                            <div className="space-y-2">
                              <textarea
                                rows={3}
                                value={replyDrafts[rev.id]}
                                onChange={e => setReplyDrafts({ ...replyDrafts, [rev.id]: e.target.value })}
                                className="w-full p-2.5 text-xs rounded-xl border border-[#E5E1D6] bg-white text-[#20231F]"
                              />
                              <div className="flex justify-end gap-2">
                                <button
                                  onClick={() => handleSubmitReply(rev)}
                                  disabled={submittingReply}
                                  className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] cursor-pointer"
                                >
                                  {t('rep.modal.gmb.reviews.btn_publish_reply')}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <button
                              onClick={() => handleDraftReply(rev)}
                              disabled={replyingReviewId === rev.id}
                              className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1.5 transition-colors cursor-pointer"
                            >
                              <Sparkles className="w-3.5 h-3.5 text-[#C8A653]" />
                              <span>{replyingReviewId === rev.id ? t('rep.modal.gmb.reviews.btn_drafting') : t('rep.modal.gmb.reviews.btn_draft_reply')}</span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                  {reviews.length === 0 && (
                    <div className="py-8 text-center text-xs text-[#687077]">
                      {t('rep.modal.gmb.reviews.empty')}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 4: SERVICES CATALOG                                       */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'services' && (
            <div className="space-y-6">
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <div className="flex items-center justify-between pb-4 border-b border-[#F1EEE4]">
                  <div>
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      {t('rep.modal.gmb.services.title')}
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5">
                      {t('rep.modal.gmb.services.subtitle')}
                    </p>
                  </div>
                  {/* 🔴 Эта кнопка НЕ ХОДИЛА НИКУДА: она печатала «услуги
                      синхронизированы», не сделав ни одного запроса. Сообщение
                      об исходе, написанное до исхода, — не сообщение. */}
                  <button
                    onClick={() => toast(t('rep.modal.gmb.toast.services_not_pushed'), { icon: 'ℹ️' })}
                    className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] inline-flex items-center gap-1.5 cursor-pointer shadow-2xs"
                  >
                    <CheckCircle2 className="w-3.5 h-3.5 text-[#C8A653]" />
                    <span>{t('rep.modal.gmb.services.btn_push')}</span>
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5">
                  {(locationData?.services || []).map((serv, idx) => (
                    <div key={idx} className="p-4 rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] flex items-start justify-between">
                      <div>
                        <div className="text-xs font-bold text-[#20231F]">{serv.name}</div>
                        <div className="text-[11px] text-[#687077] mt-0.5">{serv.category || t('rep.modal.gmb.services.default_category')}</div>
                      </div>
                      <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-[#FAF4E5] text-[#A97F2E]">
                        {serv.price || t('rep.modal.gmb.services.verified')}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 5: AUTOPILOT SETTINGS                                     */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'autopilot' && (
            <div className="space-y-6">
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-6">
                <div>
                  <h3 className="text-base font-serif font-bold text-[#20231F]">
                    {t('rep.modal.gmb.autopilot.title')}
                  </h3>
                  <p className="text-xs text-[#687077] mt-0.5">
                    {t('rep.modal.gmb.autopilot.subtitle')}
                  </p>
                </div>

                <div className="space-y-4 divide-y divide-[#F1EEE4]">
                  <div className="pt-4 flex items-center justify-between">
                    <div>
                      <div className="text-xs font-bold text-[#20231F]">{t('rep.modal.gmb.autopilot.sync_title')}</div>
                      <div className="text-[11px] text-[#687077]">{t('rep.modal.gmb.autopilot.sync_desc')}</div>
                    </div>
                    <input
                      type="checkbox"
                      checked={autopilotEnabled}
                      onChange={e => setAutopilotEnabled(e.target.checked)}
                      className="w-4 h-4 accent-[#C8A653] cursor-pointer"
                    />
                  </div>

                  <div className="pt-4 flex items-center justify-between">
                    <div>
                      <div className="text-xs font-bold text-[#20231F]">{t('rep.modal.gmb.autopilot.posts_title')}</div>
                      <div className="text-[11px] text-[#687077]">{t('rep.modal.gmb.autopilot.posts_desc')}</div>
                    </div>
                    <div className="flex items-center gap-3">
                      <select
                        value={autopilotPostDay}
                        onChange={e => setAutopilotPostDay(e.target.value)}
                        className="h-8 px-2 text-xs rounded-lg border border-[#E5E1D6] bg-[#FCFBF8]"
                      >
                        <option value="Monday">Monday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Friday">Friday</option>
                      </select>
                      <input
                        type="checkbox"
                        checked={autopilotWeeklyPost}
                        onChange={e => setAutopilotWeeklyPost(e.target.checked)}
                        className="w-4 h-4 accent-[#C8A653] cursor-pointer"
                      />
                    </div>
                  </div>

                  <div className="pt-4 flex items-center justify-between">
                    <div>
                      <div className="text-xs font-bold text-[#20231F]">{t('rep.modal.gmb.autopilot.reviews_title')}</div>
                      <div className="text-[11px] text-[#687077]">{t('rep.modal.gmb.autopilot.reviews_desc')}</div>
                    </div>
                    <input
                      type="checkbox"
                      checked={autopilotReviewReply}
                      onChange={e => setAutopilotReviewReply(e.target.checked)}
                      className="w-4 h-4 accent-[#C8A653] cursor-pointer"
                    />
                  </div>
                </div>

                <div className="pt-4 border-t border-[#F1EEE4] flex justify-end">
                  <button
                    onClick={handleSaveAutopilot}
                    className="h-9 px-5 rounded-xl text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] inline-flex items-center gap-2 cursor-pointer shadow-xs"
                  >
                    <Check className="w-3.5 h-3.5 text-[#C8A653]" />
                    <span>{t('rep.modal.gmb.autopilot.btn_save')}</span>
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>

      </div>
    </div>
  );
};

export default GmbCommandModal;
